import axios from "axios";
import AuthState from "../Auth/Enums/AuthState";
import LocalStorageHelper from "../Helpers/LocalStorageHelper";
import OAuthConfiguration from "./OAuthConfiguration";

const AGOL_REDIRECT_URL = window.location.origin + "?type=agol";
const AGOL_URL = "https://www.arcgis.com/sharing/rest/oauth2/authorize?" +
	"client_id=" + __AGOL_CONFIG.appId + "&" +
	"response_type=code&" + // "response_type=token&" +
	"expiration=20160&" + // two weeks
	"redirect_uri=" + AGOL_REDIRECT_URL;

const getAGOLNewTokens = (refreshToken) => {
	const AGOL_REFRESH_URL = "https://www.arcgis.com/sharing/rest/oauth2/token?" +
		"client_id=" + __AGOL_CONFIG.appId + "&" +
		"grant_type=exchange_refresh_token&" +
		"refresh_token=" + refreshToken + "&" +
		"redirect_uri=" + AGOL_REDIRECT_URL;

	axios.post(AGOL_REFRESH_URL)
		.then((result) => {
			onAGOLTokenReturn(result, false);
		})
		.catch((error) => {
			console.error("TOKEN error", error);
		});
};

const onAGOLTokenReturn = (result, redirect) => {
	const tokenDetails = result.data;

	if (typeof result.data.error !== "undefined") {
		console.warn("TOKEN ERROR", result);
		// TODO: do we need to redirect? e.g. window.location.href = window.location.origin;
		OAuthStore.configs.agol.error.set(result.data.error.message);
		LocalStorageHelper.clear("agol_token");
		return;
	}

	const expiresIn = (Date.now() + (parseInt(tokenDetails.expires_in) * 1000));

	OAuthStore.configs.agol.token.username.set(tokenDetails.username);
	OAuthStore.configs.agol.token.access.set(tokenDetails.access_token);
	OAuthStore.configs.agol.token.refresh.set(tokenDetails.refresh_token);
	OAuthStore.configs.agol.token.expires.set(expiresIn);
	OAuthStore.configs.agol.authState.set(AuthState.LOGGED_IN);

	LocalStorageHelper.set("agol_token", JSON.stringify({
		username: tokenDetails.username,
		access_token: tokenDetails.access_token,
		refresh_token: tokenDetails.refresh_token,
		expires_in: expiresIn
	}));

	if (redirect) {
		window.location.href = window.location.origin;
	}
	else {
		setTimeout(() => {
			getAGOLNewTokens(tokenDetails.refresh_token);
		}, (tokenDetails.expires_in - 60) * 1000);
	}
};

const OAuthStore = {
	configs: {
		agol: new OAuthConfiguration("agol", __AGOL_CONFIG.appId, AGOL_URL)
	},
	init: () => {
		if (window.location.href.indexOf("?type=agol") >= 0) {
			const url = new URL(window.location.href);
			const code = url.searchParams.get("code");
			if (code !== null) {
				const AGOL_AUTHORIZATION_URL = "https://www.arcgis.com/sharing/rest/oauth2/token?" +
					"client_id=" + __AGOL_CONFIG.appId + "&" +
					"grant_type=authorization_code&" +
					"code=" + code + "&" +
					"redirect_uri=" + AGOL_REDIRECT_URL;

				axios.post(AGOL_AUTHORIZATION_URL)
					.then((result) => {
						onAGOLTokenReturn(result, true);
					})
					.catch((error) => {
						console.error("POST error", error);
					});
			}
		}
		else {
			const has = LocalStorageHelper.has("agol_token");
			if (has) {
				const tokenDetails = JSON.parse(LocalStorageHelper.get("agol_token"));
				console.log("tokenDetails", tokenDetails);
				console.log("token expires", tokenDetails.expires_in);

				// If we have the token, always exchange on new page load. Simplified the flow a bit.
				getAGOLNewTokens(tokenDetails.refresh_token);
			}
		}
	}
};
export default OAuthStore;
